import { useMutation } from "@tanstack/react-query";
import { get, getChartsBaseUrl, post } from "./request";

export function useAuditReport(onSuccess?: any, onError?: any) {
    const { mutate: auditReport, error, isLoading: exporting } = useMutation(
        ['auditReport'],
        async (payload: any) => await get(`/api/v1/s3_files/download`, payload, null, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response: any) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { auditReport, error, exporting };
}

export function useAuditReportForVendor(onSuccess?: any, onError?: any) {
    const { mutate: auditReportVendor, error, isLoading: exporting } = useMutation(
        ['auditReportVendor'],
        async (payload: any) => await get(`/api/v1/s3_files/download`, payload, null, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response: any) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { auditReportVendor, error, exporting };
}

export function useExportVendorCategories(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportLaws'],
        async (payload: any) => await post('/api/v1/vendor_categories/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportLaws(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportLaws'],
        async (payload: any) => await post('/api/v1/laws/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportAct(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportAct'],
        async (payload: any) => await post('/api/v1/acts/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportHolidayList(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportHolidayList'],
        async (payload: any) => await post('/api/v1/holidays/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportAttendanceConfig(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportAttendanceConfig'],
        async (payload: any) => await post('/api/v1/attendances/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportLeaveConfig(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportLeaveConfig'],
        async (payload: any) => await post('/api/v1/leaves/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportEmployees(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportEmployees'],
        async (payload: any) => await post('/api/v1/employees/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportEmployeesLeaveCredit(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportEmployeesLeaveCredit'],
        async (payload: any) => await post('/api/v1/employee_leave_credits/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportEmployeesLeaveAvailed(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportEmployeesLeaveAvailed'],
        async (payload: any) => await post('/api/v1/employee_leave_availeds/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportEmployeesAttendance(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportEmployeesAttendance'],
        async (payload: any) => await post('/api/v1/employee_attendances/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportEmployeesWage(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportEmployeesWage'],
        async (payload: any) => await post('/api/v1/employee_wages/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}


export function useExportActivities(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportActivity'],
        async (payload: any) => await post('/api/v1/activities/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportRules(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportRules'],
        async (payload: any) => await post('/api/v1/rules/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportStates(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportStates'],
        async (payload: any) => await post('/api/v1/states/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportCities(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportCities'],
        async (payload: any) => await post('/api/v1/cities/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}
export function useExportActStateMappings(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportActStateMappings'],
        async (payload: any) => await post('/api/v1/act_state_mappings/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportRuleCompliance(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportRuleCompliances'],
        async (payload: any) => await post('/api/v1/rule_compliance_details/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportRuleComplianceMapping(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportRuleComplianceMappings'],
        async (payload: any) => await get('/api/v1/rule_compliance_details/export', payload, null, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportCompanies(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportCompanies'],
        async (payload: any) => await post('/api/v1/companies/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportVendors(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportCompanies'],

        async (payload: any) => await post('/api/v1/vendor_registrations/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }

        }

    );
    return { exportRecords, error, exporting };
}

export function useExportAssociateCompanies(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportAssociateCompanies'],
        async (payload: any) => await post('/api/v1/companies/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportVendorLocations(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportVendorLocations'],
        async (payload: any) => await post('/api/v1/vendor_location_mappings/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportCompanyLocations(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportCompanyLocations'],
        async (payload: any) => await post('/api/v1/company_location_mappings/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportUserDepartments(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportUserDepartments'],
        async (payload: any) => await post('/api/v1/user_department_mappings/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportUsers(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportUsers'],
        async (payload: any) => await post('/api/v1/users/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportVerticals(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportVerticals'],
        async (payload: any) => await post('/api/v1/verticals/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function useExportDepartments(onSuccess?: any, onError?: any) {
    const { mutate: exportRecords, error, isLoading: exporting } = useMutation(
        ['exportDepartments'],
        async (payload: any) => await post('/api/v1/department/export', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportRecords, error, exporting };
}

export function getAuditReportFileName(row: any, contentType: string) {
    const {company, associate_company, location, month} = row;
    let fileNames: string[] = ['Audit_Report', company.code, associate_company.code, location.code, month];
    const fileExt = contentType.split('/')[1] || 'pdf';
    return `${fileNames.join('_')}.${fileExt}`;
}

export function useExportSummaryAuditReport(onSuccess?: any, onError?: any) {
      const { mutate: exportSummaryAuditReport, error, isLoading: exporting } = useMutation(
          ['exportSummaryAuditReport'],
          async (payload: any) => await post('/api/v1/vendor_location_audits/export_summary_audit_report', payload),
          {
              onError,
              onSuccess: (response) => {
                  const data = (response || {}).data || {};
                  onSuccess(data);
              }
          }
      );
      return { exportSummaryAuditReport, error, exporting };
  }